import React from 'react'
import { Link } from 'react-router-dom'

function EachFeedActivity({title,desc, author, author_image,
                            date, mediaFiles,
                            upvote_count, downvote_count, discussion_id }) {

  return (

    <div className='my-8 relative'>


    <Link to={`/discussions/${discussion_id}`}>
    <div className="absolute top-0 right-2 h-[40px] w-[40px] sm:h-[60px] sm:w-[60px]">
                        <img
                        src={author_image}
                        alt="Author's avatar"
                        className={`w-full h-full rounded-full`}
                        />
                    </div>

        <div className='space-y-2'>
        <p className='font-bold'>{title}</p>
        <p className=''>{desc?.slice(0,70)}...</p>

        <p className='text-[12px] font-semibold mt-3'>Created by: {author}</p>
        </div>
    </Link>


    {mediaFiles.length > 0 &&
    <div className='flex flex-wrap justify-center'>
    {mediaFiles.map((item,idx) => {
        return  <div  key={idx} className='m-2 h-[120px] md:h-[200px] lg:h-[250px] w-[42%] sm:w-[45%]'>
              {item.endsWith('mp4')
              ?
              <video
              className="w-full h-full object-cover rounded-xl"
              controls>
              <source src={item} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            :
            <Link to={item} target="_blank">
                <img
                    src={item}
                    alt={`Media`}
                    className="w-full h-full object-cover rounded-xl"
                />
            </Link>
                      }
    </div>
    })
    }
    </div>

    }

    <div className={`flex justify-end my-3 `}>
    <Link to={`/discussions/${discussion_id}`}>
        <button className='px-6 sm:px-10 py-2 bg-[#474B7D] hover:bg-[#444770] rounded-md
        text-sm sm:text-[16px]'>Open Discussion</button>
    </Link>
    </div>
    <p className='text-[10px]'>{date}</p>
</div>
  )
}

export default EachFeedActivity
